
// components
import GridPageAbstract from '../../abstract/GridPageAbstract';

export default class FiltersBanksPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'filtersBanks';
        this.Server = this.props.context.getState().server.filtersBanks;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['officialName', 'bankCode', 'country'];
        this.showDatePicker = false;

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'officialName',
                    label: 'officialName',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'aliases',
                    label: 'aliases',
                    alignRight: false,
                    cell: 'Tags',
                    type: 'tags',
                    displayGrid: true
                },
                {
                    id: 'bankCode',
                    label: 'bankCode',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'country',
                    label: 'country',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'logoAvailable',
                    label: 'logoAvailable',
                    alignRight: false,
                    cell: 'Checkbox',
                    type: 'boolean',
                    displayGrid: true
                }
            ];
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

